module.exports = (str) => {
  const arr = str?.split(' ');

  //loop through each element of the array and capitalize the first letter.

  for (var i = 0; i < arr?.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  return arr?.join(' ') || '';
};
